module.exports = __webpack_public_path__ + "img/icon-site.483ef6b7.svg";